export default __webpack_public_path__ + "static/media/sl.58cded4c.png";